export function getPreviousPlanBalance(amount?: number | null): number {
  const parsed = Number(amount);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}
